var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.show)?_c('el-badge',{attrs:{"value":"DEV","type":"primary"}},[_c('div',{staticClass:"dev-only-wrapper"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }